import {Component} from 'react';
import {Container, Icon, Popup} from 'semantic-ui-react';

export default class ReservePriceFieldTip extends Component {
  render() {
    return (
      <Popup on="click" wide
             position="right center"
             trigger={<Icon name="help circle outline" link/>}>
        <Container fluid>
          <p>
            If left blank this will display as &lsquo;N/A&rsquo; on the report output.
          </p>
        </Container>
      </Popup>
    );
  }
}
